<div class="c-container-node" [ngSwitch]="entry.type" [hidden]="isHidden">
  <rl-virtualiser
    *ngSwitchCase="'items'"
    [ngClass]="classes"
    class="c-container-node__item"
  >
    <ng-template
      #childComponentTemplate
      let-onUpdateDimension="onDimensionChange"
    >
      <rl-view-item-smart
        [itemId]="entry.id"
        [depth]="depth"
        (changeDimension)="onUpdateDimension($event)"
      >
      </rl-view-item-smart>
    </ng-template>

    <ng-template #placeholderComponentTemplate>
      <rl-list-item-placeholder [itemId]="entry.id"></rl-list-item-placeholder>
    </ng-template>
  </rl-virtualiser>

  <section
    *ngSwitchCase="'sections'"
    class="c-container-node__section"
    [ngClass]="classes"
  >
    <rl-view-section
      [section]="sectionsById.get(entry.id)"
      [depth]="depth"
      class="c-list-section"
    >
    </rl-view-section>

    <div
      *ngIf="!containerChildren.isEmpty()"
      class="c-container-node__section__children"
    >
      <ng-container *ngFor="let entryChild of containerChildren">
        <rl-view-container-node
          [containerStructure]="containerStructure"
          [depth]="depth + 1"
          [entry]="entryChild"
          [entryVisibility]="entryVisibility"
          [sectionsById]="sectionsById"
          class="c-container-node__section__child"
        >
        </rl-view-container-node>
      </ng-container>
    </div>
  </section>
</div>
